// removed by extract-text-webpack-plugin
module.exports = {"faqs-header":"faqs-header","faqs-title":"faqs-title","faqs-wrapper":"faqs-wrapper","faqs-bottom":"faqs-bottom","faqs-button-container":"faqs-button-container","faqs-button":"faqs-button"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/static/iconfaqs/iconfaqs.scss
// module id = 2742
// module chunks = 1